import React from "react";
import styled from "styled-components/macro";

import {
  Box,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Typography as MuiTypography,
} from "@material-ui/core";

import { rgba } from "polished";

import { spacing } from "@material-ui/system";

const Card = styled(MuiCard)(spacing);

const CardShell = styled(Card)`
  min-height: 100%;
  overflow: hidden;
  border-radius: 22px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 22px 50px rgba(15, 23, 42, 0.08);
  background: radial-gradient(
      circle at top right,
      rgba(56, 189, 248, 0.16),
      transparent 42%
    ),
    linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
`;

const CardContent = styled(MuiCardContent)`
  position: relative;
  padding: 24px;

  &:last-child {
    padding-bottom: 24px;
  }
`;

const IconBadge = styled.div`
  position: absolute;
  top: 22px;
  right: 22px;
  width: 52px;
  height: 52px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  color: #0f172a;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(12px);
`;

const Label = styled(MuiTypography)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
  font-weight: 700;
`;

const Value = styled(MuiTypography)`
  color: #0f172a;
  font-size: clamp(1.9rem, 2vw, 2.6rem);
  font-weight: 800;
  letter-spacing: -0.03em;
`;

const AccentBar = styled.div`
  width: 68px;
  height: 6px;
  border-radius: 999px;
  background: ${(props) =>
    `linear-gradient(90deg, ${rgba(props.percentagecolor, 0.95)} 0%, ${rgba(
      props.percentagecolor,
      0.28
    )} 100%)`};
`;

const Percentage = styled(MuiTypography)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  color: #64748b;

  span {
    color: ${(props) => props.percentagecolor};
    font-weight: 700;
    background: ${(props) => rgba(props.percentagecolor, 0.1)};
    padding: 6px 10px;
    border-radius: 999px;
  }
`;

const Stats = ({
  title,
  amount,
  percentageText,
  percentagecolor,
  IconComponent,
}) => {
  return (
    <CardShell mb={3}>
      <CardContent>
        <IconBadge>
          <IconComponent size={22} />
        </IconBadge>
        <Label mb={2}>{title}</Label>
        <Value variant="h3" mb={2}>
          <Box fontWeight="fontWeightRegular">{amount}</Box>
        </Value>
        <AccentBar percentagecolor={percentagecolor} />
        <Percentage
          variant="subtitle2"
          mt={3}
          color="textSecondary"
          percentagecolor={percentagecolor}
        >
          <span>{percentageText}</span> Variacion reciente
        </Percentage>
      </CardContent>
    </CardShell>
  );
};

export default Stats;
